import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

/* Temayı belgeye yaz: CSS değişkenleri (gövde arka planı, odak halkası,
   kâğıt dokusu) buna bakıyor. Doku ayrı bir bayrak, temanın adıyla
   karıştırılmamalı: doku kapalı bir krem tema da olabilir. */
import { TEMA_ADI, DOKU } from "./data/constants";
document.documentElement.setAttribute("data-tema", TEMA_ADI);
document.documentElement.setAttribute("data-doku", DOKU ? "acik" : "kapali");


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
